const blogData = {
  categories: [
    "AC Cleaning",
    "Deep Cleaning",
    "Home Cleaning",
    "Home Maintenance Tips",
    "Uncategorized",
  ],
  blogPosts: [
    {
      title:
        "DIY Air  Conditioner Maintenance Tips to Extend AC Life in Kochi’s Humid Climate",
      excerpt:
        "Kochi’s coastal beauty comes with its own set of challenges — especially when it comes to appliances like air conditioners. With high humidity, salt in the air...",
      category: "AC Cleaning",
      slug: "diy-ac-maintenance",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/gettyimages-1308375457-612x612.webp",
    },
    {
      title: "Top 10 Easy Ways to Lower Your Summer Electricity Costs at Home!",
      excerpt:
        "Summer is here, and along with the scorching heat comes the dreaded spike in electricity bills. As temperatures soar, our air conditioners work overtime...",
      category: "AC Cleaning",
      slug: "lower-electricity-bill",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/gettyimages-2206342744-612x612.webp",
    },
    {
      title: "5 Signs It’s Time to Repair or Replace Your AC System",
      excerpt:
        "Your air conditioning system works hard to keep your home comfortable, especially during hot summer months. Like any appliance, AC units don’t last forever...",
      category: "AC Cleaning",
      slug: "repair-or-replace-ac",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/checking-conditioner.webp",
    },
    {
      title: "Why Your AC Isn’t Cooling Common Issues & Fixes",
      excerpt:
        "When your air conditioning system fails to provide the cool comfort you expect, especially during sweltering summer months, it can quickly transform your home...",
      category: "AC Cleaning",
      slug: "ac-not-cooling",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/repairman-doing-air-conditioner-service.webp",
    },
    {
      title:
        "Top AC Repair Service and Maintenance: Everything You Need to Know About Your Air Conditioner",
      excerpt:
        "Welcome to the ultimate guide on air conditioning maintenance and repair from Oh Yes World. As a leading provider of top AC repair services in Bangalore and Kochi...",
      category: "AC Cleaning",
      slug: "top-ac-repair-maintenance",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/vecteezy_male-technician-cleaning-air-conditioner-indoors-repairman_7708644.webp",
    },
    {
      title: "How the Best AC Service in Bangalore Can Keep You Cool",
      excerpt:
        "When the heat is on, the last thing you need is for your AC to break down on a very hot day Picture the scorching heat, sleepless nights, and increasing anxiety...",
      category: "AC Cleaning",
      slug: "best-ac-service-bangalore",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/person-taking-care-office-cleaning.webp",
    },
    {
      title:
        "Discover Top-Rated AC and Plumbing Services in Kochi and Bangalore with Our Home Service App",
      excerpt:
        "Are you tired of searching for reliable AC and plumbing services in Kochi? Look no further! With our innovative home service app, OH Yes App...",
      category: "AC Cleaning",
      slug: "discover-home-service-app",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/vecteezy_male-technician-repairing-air-conditioner-in-uniform_4901379.webp",
    },
    {
      title: "Top AC Maintenance Tips to Keep Your Cool This Summer",
      excerpt:
        "Nowadays, Summer season can lead to an unabating situation. The intensity of hotness is increasing day by day and your air conditioner is your stylish defense against the scorching heat...",
      category: "AC Cleaning",
      slug: "top-ac-maintenance-tips",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/vecteezy_technician-are-checking-outdoor-air-conditioner_1226758.webp",
    },
    {
      title: "How Clean AC Units Save You Money on Your Bills",
      excerpt:
        "Air conditioners have become a necessity and cater to thousands of households across the country. However, almost every other user complains about the high energy consumption...",
      category: "AC Cleaning",
      slug: "clean-ac-save-money",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/coworkers-servicing-hvac-system.webp",
    },
    {
      title:
        "The Advantages of Hiring a Professional AC Cleaning Service Provider",
      excerpt:
        "With the scorching summer heat approaching, air conditioners have become more than a necessity. Many people have started looking at air conditioners more as an investment...",
      category: "AC Cleaning",
      slug: "advantages-pro-ac-cleaning",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/ac-cleaning/stock-photo-young-professional-repairman-fixing-air-conditioner-hanging-white-brick-wall.jpeg",
    },
    {
      title:
        "The Ultimate Guide to Deep Cleaning Services in Kochi, Kerala: Transform Your Home",
      excerpt:
        "Looking for the best deep cleaning service in Kochi that delivers exceptional results at affordable prices? Oh Yes World provides comprehensive deep cleaning solutions...",
      category: "Deep Cleaning",
      slug: "ultimate-guide-deep-cleaning",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/deep-cleaning/240_F_603304379_E45LvFaBRRZ4Kx2uzW5E3NaUY7TH6LTy.jpg",

     
    },
    {
      title: "What Makes Our Cleaning Service Stand Out in Bangalore!",
      excerpt:
        "When it comes to maintaining a spotless and comfortable home in the bustling city of Bangalore, finding reliable service providers can be challenging...",
      category: "Deep Cleaning",
      slug: "cleaning-service-bangalore",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/deep-cleaning/medium-shot-woman-cleaning-home.webp",

    },
    {
      title:
        "Unveiling the Ultimate Home Refresh: What’s Really Included in the Oh Yes Deep Cleaning Service.",
      excerpt:
        "What Items Are Included in a Basic Deep Cleaning Service? Are you wondering what exactly happens during a deep cleaning service?...",
      category: "Deep Cleaning",
      slug: "deep-cleaning-included-details",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/deep-cleaning/240_F_511929539_hkrzPKGI6pEA8TwUfrwrB0g73FyEaowM.jpg",

    },
    {
      title: "Effective Pesticide Control for a Pest-Free Home in 2023",
      excerpt:
        "As homeowners in 2023, one of our top priorities is maintaining a clean and pest-free living space. Pests can be more than just a nuisance...",
      category: "Deep Cleaning",
      slug: "effective-pesticide-control",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/deep-cleaning/240_F_358075935_l4shQMh6vkqVBeXfQGZDyE9BCMtV8q6k.jpg",

    },
    {
      title: "What to Expect During a Deep Cleaning Service? A Complete Guide",
      excerpt:
        "Irrespective of how clean the surface looks, you never know what reality can be. Waking up on a clean bed, working in clean surroundings...",
      category: "Deep Cleaning",
      slug: "what-to-expect-deep-clean",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/deep-cleaning/front-view-woman-cleaning-home.webp",

    },
    {
      title:
        "Why Oh Yes World Home Care Solutions is the Best Plumbing Service Company in Town.",
      excerpt:
        "The Importance of Quality Plumbing Installation and Service Every homeowner knows that plumbing issues never arrive at convenient times...",
      category: "Home Cleaning",
      slug: "best-plumbing-service-company",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/240_F_379597350_ZKlo68NKYIw7RgwchWgxx31VJfHPneYC.jpg",
    },
    {
      title:
        "The Importance of a Professional Water Tank Cleaning Service in Bangalore",
      excerpt:
        "Imagine drinking water whose contamination site is the hiding grounds for invisible toxins and toxic bacteria in an unwashed and uncleanly kept tank...",
      category: "Home Cleaning",
      slug: "water-tank-cleaning-bangalore",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/full-shot-people-cleaning-room-together.webp",
    },
    {
      title: "Bring Professional Cleaning to Every Corner of Bangalore",
      excerpt:
        "Simplify your Home Maintenance with Oh yes: Discover top-notch home cleaning services in Bangalore with Oh Yes App!...",
      category: "Home Cleaning",
      slug: "professional-cleaning-bangalore-app",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/josue-michel-MwxsRSG1A2s-unsplash.webp",
    },
    {
      title:
        "Effortless Home Maintenance: How Oh yes Keeps Your NRI Property Pristine from Afar",
      excerpt:
        "As an NRI, managing the upkeep of your property back home can be challenging. Distance, time constraints, and uncertainty about the condition...",
      category: "Home Cleaning",
      slug: "nri-property-maintenance",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/young-girl-is-wearing-yellow-gloves-while-cleaning-kichen-room-with-duster-her-house.webp",
    },
    {
      title: "Turn Your Home Into a Summer Paradise",
      excerpt:
        "Elevate Your Outdoor Space with Top Services for Ultimate Relaxation and Entertainment! As the days grow longer and the temperatures rise, there’s no better time...",
      category: "Home Cleaning",
      slug: "summer-home-paradise",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/cdc-VRpjDw3WqqI-unsplash.webp",
    },
    {
      title:
        "Top Winter Home Maintenance Tips: Getting Your House Ready for the Holidays",
      excerpt:
        "As the holiday season approaches, it’s the perfect time to ensure that your home is not only cozy and welcoming but also well-prepared to handle the winter weather...",
      category: "Home Cleaning",
      slug: "winter-home-maintenance",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/240_F_222177645_vmWSSXawa6TY2AXOqrPCB6vWTLwwVGBG.webp",
    },
    {
      title: "The 10 Benefits of Hiring Professional Home Cleaning Services",
      excerpt:
        "Cleaning is a time-consuming and tiresome job. It is no less than a challenge to manage and clean all the surfaces of the home...",
      category: "Home Cleaning",
      slug: "benefits-pro-cleaning",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/240_F_165039741_UhJjKkPUOcL0BETMxgf7BcOa6nhTEpHZ.webp",
    },
    {
      title: "Top 6 Signs You Need a Professional Electrician in Kochi",
      excerpt:
        "Electricity powers everything we do — from lights and fans to appliances and internet routers. But when something goes wrong, it can range from mildly inconvenient...",
      category: "Home Maintenance Tips",
      slug: "signs-need-electrician",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-cleaning/240_F_165039741_UhJjKkPUOcL0BETMxgf7BcOa6nhTEpHZ.webp",
    },
    {
      title: "Fuse vs MCB: What’s Best for Homes in Kochi?",
      excerpt:
        "Every modern home needs a reliable way to protect itself from electrical faults. But when it comes to choosing between a traditional fuse and a modern MCB...",
      category: "Home Maintenance Tips",
      slug: "fuse-vs-mcb",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/sergej-karpow-zWL_sYw10gs-unsplash.jpg",
    },
    {
      title: "7 Common Plumbing Problems in Kochi Homes—and How to Fix Them",
      excerpt:
        "Living in Kochi has its unique perks—but when it comes to plumbing, the city’s coastal humidity, aging pipelines, and monsoon-heavy environment can pose real challenges...",
      category: "Home Maintenance Tips",
      slug: "common-plumbing-problems",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/bermix-studio-iwz5tmhjl7o-unsplash.jpg",
    },
    {
      title:
        "Top 6 Mistakes to Avoid When Painting Your Home in Kochi (DIY or Not)",
      excerpt:
        "Painting your home, whether you’re doing it yourself or hiring a professional, seems like a straightforward task. But in reality, it’s a process that requires preparation...",
      category: "Home Maintenance Tips",
      slug: "painting-mistakes-kochi",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/theme-photos-Klby0nxseY8-unsplash.jpg",
    },
    {
      title:
        "Water Dampness in Walls: Causes & Solutions Oh Yes World Home Cleaning",
      excerpt:
        "Water dampness in walls is one of the most common and frustrating problems homeowners face. At Oh Yes World, the complete home cleaning solution, we understand how devastating...",
      category: "Home Maintenance Tips",
      slug: "water-dampness-solutions",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/annie-gray-WEWTGkPUVT0-unsplash.jpg",
    },
    {
      title:
        "How to Paint House Walls Like a Pro: Expert Tips from Our Trusted House Painting Service",
      excerpt:
        "Transforming your home’s appearance doesn’t have to be a daunting task when you know the right techniques. Whether you’re considering DIY painting or seeking professional...",
      category: "Home Maintenance Tips",
      slug: "paint-house-like-a-pro",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/pandu-agus-wismoyo-7OgQ-Ze7BXQ-unsplash.jpg",
    },
    {
      title: "Expert Tips to Budget for Home Repairs and Maintenance",
      excerpt:
        "Owning a home can be a great experience, but it’s a commitment that demands its own share of responsibilities. Sudden leakages here and there, repairs and provisions for regular...",
      category: "Home Maintenance Tips",
      slug: "budget-for-home-repairs",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/raze-solar-Scaj0T40nFI-unsplash.jpg",
    },
    {
      title:
        "Step Up from Regular Cleaning with the Best Deep Cleaning Service in Bangalore",
      excerpt:
        "A clean home is pleasing to the eye but also healthy for you. While daily cleaning keeps things straight, note that cleanliness extends far beyond what meets the eye...",
      category: "Home Maintenance Tips",
      slug: "step-up-deep-cleaning",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/pexels-shkrabaanthony-4981803.jpg",
    },
    {
      title:
        "How Professional Pest Control Service in Bangalore Handles Seasonal Pest Problems",
      excerpt:
        "Imagine entering your kitchen with ants marching on your countertops, or hearing that eerie thumping of rats scurrying within your walls...",
      category: "Home Maintenance Tips",
      slug: "professional-pest-control",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/iqbalstock-home-6869858_1920.jpg",
    },
    {
      title: "Setting Ourselves Apart: How Oh yes Home Solutions Stands Out?",
      excerpt:
        "In today’s competitive industry, finding reliable home maintenance service providers can be akin to finding a needle in a haystack. It’s essential to differentiate your company...",
      category: "Home Maintenance Tips",
      slug: "how-ohyes-stands-out",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/iqbalstock-home-6869866_1920.jpg",
    },
    {
      title: "Building Dreams With Oh yes Home Solutions",
      excerpt:
        "Embarking on the journey of constructing a new home is an exciting and transformative experience. In 2024, with technological advancements, innovative design trends, and a growing emphasis...",
      category: "Home Maintenance Tips",
      slug: "building-dreams-home-solutions",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/home-maintainence-tips/gettyimages-1131420200-612x612.jpg",
    },
    {
      title:
        "Top 7 Signs Your Home in Kochi Needs a Professional Plumbing Check — Before It’s Too Late",
      excerpt:
        "In a coastal city like Kochi, where humidity, heavy rains, and aging infrastructure are common, plumbing issues can sneak up on you...",
      category: "Uncategorized",
      slug: "plumbing-check-kochi",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/4.jpg",
    },
    {
      title:
        "Welcome to our Home Service Solution Complete this form to get your personalized 12- moth home service Package.",
      excerpt:
        "Personal Details First Name Last Name Email SubmitThe form has been submitted successfully!There has been some error while submitting the form. Please verify all...",
      category: "Uncategorized",
      slug: "home-service-package-form",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/3.jpg",
    },
    {
      title:
        "Why Earthing Is Critical in Homes — And How to Know If Yours Is Failing",
      excerpt:
        "Most homeowners in Kochi rarely think about earthing—until something goes wrong. Yet, it’s one of the most important safety systems in any building’s electrical setup...",
      category: "Uncategorized",
      slug: "electrical-earthing",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/9.jpg",
    },
    {
      title: "DIY Electrical Fixes You Should Avoid at All Costs",
      excerpt:
        "In the age of YouTube tutorials and DIY home fixes, it’s tempting to try and repair that flickering light, replace a socket, or fix a tripping switchboard yourself...",
      category: "Uncategorized",
      slug: "avoid-diy-electrical",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/5.jpg",
    },
    {
      title:
        "Interior vs Exterior Painting: What Homeowners Need to Know Before Booking",
      excerpt:
        "Planning to give your home a fresh coat of paint? Whether you’re revamping your interiors or restoring your building’s exterior, it’s important to understand that interior...",
      category: "Uncategorized",
      slug: "interior-vs-exterior-painting",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/8.jpg",
    },
    {
      title:
        "Is Your Wall Paint Peeling in Kochi’s Humid Weather? Here’s What You Can Do",
      excerpt:
        "Living in Kochi comes with many benefits—lush greenery, sea breeze, and a peaceful lifestyle. However, the region’s high humidity and frequent monsoons often lead to a common problem...",
      category: "Uncategorized",
      slug: "wall-paint-peeling-kochi",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/2.jpg",
    },
    {
      title:
        "What’s Included in Our Professional House Painting Service in Kochi?",
      excerpt:
        "When it comes to giving your home a fresh look, house painting is one of the most impactful and cost-effective improvements you can make. But many homeowners...",
      category: "Uncategorized",
      slug: "house-painting-service-kochi",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/6.jpg",
    },
    {
      title:
        "Stay Cool in Kochi: Why Regular AC Maintenance from Oh Yes Services is a Smart Move",
      excerpt:
        "Living in Kochi means enjoying beautiful backwaters and coastal breezes — but also dealing with high humidity and scorching heat, especially in the summer...",
      category: "Uncategorized",
      slug: "regular-ac-maintenance-kochi",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/1.jpg",
    },
    {
      title:
        "Why Kochi Residents Choose Oh Yes World Home Cleaning Solutions for Their Deep Cleaning Needs",
      excerpt:
        "Life in Kochi moves at a fast pace. Between juggling work commitments, family responsibilities, and the city’s vibrant social scene, finding time for thorough home cleaning...",
      category: "Uncategorized",
      slug: "kochi-deep-cleaning-choice",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/7.jpg",
    },
    {
      title:
        "The Ultimate Guide to Cleaning Tile Floors: Expert Tips for Spotless Results",
      excerpt:
        "Tile floors are a popular choice for homes due to their durability, water resistance, and timeless appeal. However, maintaining their pristine appearance requires proper cleaning...",
      category: "Uncategorized",
      slug: "guide-to-cleaning-tile-floors",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-bruceclarkinoc-3701455.webp",
    },
    {
      title:
        "Renovating Your Home? Don’t Skip on a Professional Electrician Service",
      excerpt:
        "Home renovation projects can be exciting and transformative, breathing new life into your living space. Whether you’re updating a single room or undertaking a complete home makeover...",
      category: "Uncategorized",
      slug: "professional-electrician-renovation",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/lotus-design-n-print-BAVam-y_9Wg-unsplash.webp",
    },
    {
      title: "10 Hidden Spots in Your Home You’re Probably Forgetting to Clean",
      excerpt:
        "Maintaining a spotless home goes beyond the obvious surfaces we clean daily. While we diligently wipe counters and vacuum floors, numerous hidden areas accumulate dust...",
      category: "Uncategorized",
      slug: "hidden-spots-to-clean",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/spacejoy-9M66C_w_ToM-unsplash.webp",
    },
    {
      title:
        "Plumber Services You Didn’t Know You Needed for a Smooth-Running Home",
      excerpt:
        "When most homeowners think about plumbing services, they typically envision emergency plumbing repair situations—burst pipes, clogged drains, or overflowing toilets...",
      category: "Uncategorized",
      slug: "plumber-services-needed",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-clickerhappy-584399.webp",
    },
    {
      title:
        "Monsoon Home Cleaning Hacks to Keep Your House Fresh and Mold-Free",
      excerpt:
        "The monsoon season brings relief from scorching heat but also introduces unique challenges to maintaining a clean and healthy home. Increased humidity creates the perfect breeding ground...",
      category: "Uncategorized",
      slug: "monsoon-cleaning-hacks",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-vlada-karpovich-4050318.webp",
    },
    {
      title:
        "How Does a Professional Deep Cleaning Differ from a Regular Clean?",
      excerpt:
        "In today’s fast-paced world, maintaining a clean living or working space is essential for both health and peace of mind. While many of us engage in regular cleaning routines...",
      category: "Uncategorized",
      slug: "pro-vs-regular-clean",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-quirva-4030908.webp",
    },
    {
      title: "Top 7 Electrical Problems and How to Avoid Them",
      excerpt:
        "Electricity powers our modern lives, from the moment we wake up to our alarm clocks to the late-night Netflix binge sessions. However, electrical issues can disrupt our daily routines...",
      category: "Uncategorized",
      slug: "top-7-electrical-problems",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-fotoaibe-1643383.webp",
    },
    {
      title: "Why Regular Drain Cleaning is Essential for a Healthy Home",
      excerpt:
        "In the hustle and bustle of daily life, it’s easy to overlook the silent heroes of our homes: the drainage systems. At Oh Yes World, as a top-rated plumbing company...",
      category: "Uncategorized",
      slug: "regular-drain-cleaning",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-jvdm-1599791.webp",
    },
    {
      title:
        "Everything You Need to Know About Electrical Maintenance and Professional Electrician Services",
      excerpt:
        "Electrical systems are the lifeblood of modern homes, powering everything from essential appliances to entertainment devices. Yet, many homeowners remain unfamiliar with the basics...",
      category: "Uncategorized",
      slug: "electrical-maintenance-guide",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/alberto-castillo-q-mx4mSkK9zeo-unsplash.webp",
    },
    {
      title:
        "Best Interior Paints for Walls: The Ultimate Guide Of Oh Yes World House Painting Services",
      excerpt:
        "The walls of your home are like a canvas waiting to be transformed. Especially in cities like Bangalore and Kochi, whether you’re moving into a new space, refreshing your current one...",
      category: "Uncategorized",
      slug: "best-interior-paints",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-home-decor-interiors-634144-1827054.webp",
    },
    {
      title:
        "Ultimate Guide to Best Top AC repair Services: in Kochi and Bangalore",
      excerpt:
        "Why Regular AC Servicing is Important Air conditioners play a crucial role in maintaining comfort, especially in cities like Bangalore and Kochi, where temperatures can soar...",
      category: "Uncategorized",
      slug: "ultimate-ac-repair-guide",
      imageUrl:
        "https://ik.imagekit.io/enk8uafpna/uncategorized/pexels-pixabay-279719.webp",
    },
  ],
};

export default blogData;
